import { render, staticRenderFns } from "./DomainService.vue?vue&type=template&id=0fea60d5&"
import script from "./DomainService.vue?vue&type=script&lang=js&"
export * from "./DomainService.vue?vue&type=script&lang=js&"
import style0 from "./DomainService.vue?vue&type=style&index=0&id=0fea60d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports